import { isNullOrUndefined } from '@syncfusion/ej2-base';
import * as CONSTANT from './../editor-manager/base';
/**
 * `Selection` module is used to handle RTE Selections.
 */
export class NodeSelection {
    constructor(editElement) {
        this.startNodeName = [];
        this.endNodeName = [];
        this.editableElement = editElement;
    }
    saveInstance(range, body) {
        this.range = range.cloneRange();
        this.rootNode = this.documentFromRange(range);
        this.body = body;
        this.startContainer = this.getNodeArray(range.startContainer, true);
        this.endContainer = this.getNodeArray(range.endContainer, false);
        this.startOffset = range.startOffset;
        this.endOffset = range.endOffset;
        this.html = this.body.innerHTML;
        return this;
    }
    documentFromRange(range) {
        return (9 === range.startContainer.nodeType) ? range.startContainer : range.startContainer.ownerDocument;
    }
    getRange(docElement) {
        const select = this.get(docElement);
        const range = select && select.rangeCount > 0 ? select.getRangeAt(select.rangeCount - 1) : docElement.createRange();
        return (range.startContainer !== docElement || range.endContainer !== docElement
            || range.startOffset || range.endOffset || (range.setStart(docElement.body, 0),
            range.collapse(!0)),
            range);
    }
    /**
     * get method
     *
     * @param {Document} docElement - specifies the get function
     * @returns {void}
     * @hidden
     * @deprecated
     */
    get(docElement) {
        return docElement.defaultView.getSelection();
    }
    /**
     * save method
     *
     * @param {Range} range - range value.
     * @param {Document} docElement - specifies the document.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    save(range, docElement) {
        range = (range) ? range.cloneRange() : this.getRange(docElement);
        return this.saveInstance(range, docElement.body);
    }
    /**
     * getIndex method
     *
     * @param {Node} node - specifies the node value.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    getIndex(node) {
        let index;
        let num = 0;
        node = !node.previousSibling && node.tagName === 'BR' ? node : node.previousSibling;
        if (node) {
            for (let type = node.nodeType; node; null) {
                index = node.nodeType;
                num++;
                //eslint-disable-next-line
                type = index;
                node = node.previousSibling;
            }
        }
        return num;
    }
    isChildNode(nodeCollection, parentNode) {
        for (let index = 0; index < parentNode.childNodes.length; index++) {
            if (nodeCollection.indexOf(parentNode.childNodes[index]) > -1) {
                return true;
            }
        }
        return false;
    }
    getNode(startNode, endNode, nodeCollection) {
        if (this.editableElement && (!this.editableElement.contains(startNode) || this.editableElement === startNode)) {
            return null;
        }
        if (endNode === startNode &&
            (startNode.nodeType === 3 || !startNode.firstChild || nodeCollection.indexOf(startNode.firstChild) !== -1
                || this.isChildNode(nodeCollection, startNode))) {
            return null;
        }
        if (startNode.nodeType === 3 && startNode.previousSibling === endNode && endNode.nodeName === 'IMG') {
            return null;
        }
        if (nodeCollection.indexOf(startNode.firstChild) === -1 && startNode.firstChild && !this.isChildNode(nodeCollection, startNode)) {
            return startNode.firstChild;
        }
        if (startNode.nextSibling) {
            return startNode.nextSibling;
        }
        if (!startNode.parentNode) {
            return null;
        }
        else {
            return startNode.parentNode;
        }
    }
    /**
     * getNodeCollection method
     *
     * @param {Range} range -specifies the range.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    getNodeCollection(range) {
        let startNode = range.startContainer.childNodes[range.startOffset]
            || range.startContainer;
        const endNode = range.endContainer.childNodes[(range.endOffset > 0) ? (range.endOffset - 1) : range.endOffset]
            || range.endContainer;
        const tableCursor = this.processedTableImageCursor(range);
        if (tableCursor.start || tableCursor.end) {
            if (tableCursor.startName === 'TABLE' || tableCursor.endName === 'TABLE') {
                const tableNode = tableCursor.start ? tableCursor.startNode : tableCursor.endNode;
                return [tableNode];
            }
        }
        if ((startNode === endNode || (startNode.nodeName === 'BR' && startNode === range.endContainer.childNodes[range.endOffset])) &&
            startNode.childNodes.length === 0) {
            return [startNode];
        }
        if (range.startOffset === range.endOffset && range.startOffset !== 0 && range.startContainer.nodeName === 'PRE') {
            return [startNode.nodeName === 'BR' || startNode.nodeName === '#text' ? startNode : startNode.childNodes[0]];
        }
        const nodeCollection = [];
        do {
            if (nodeCollection.indexOf(startNode) === -1) {
                nodeCollection.push(startNode);
            }
            startNode = this.getNode(startNode, endNode, nodeCollection);
        } while (startNode);
        return nodeCollection;
    }
    /**
     * getParentNodeCollection method
     *
     * @param {Range} range - specifies the range value.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    getParentNodeCollection(range) {
        return this.getParentNodes(this.getNodeCollection(range), range);
    }
    /**
     * getParentNodes method
     *
     * @param {Node[]} nodeCollection - specifies the collection of nodes.
     * @param {Range} range - specifies the range values.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    getParentNodes(nodeCollection, range) {
        nodeCollection = nodeCollection.reverse();
        for (let index = 0; index < nodeCollection.length; index++) {
            if ((nodeCollection.indexOf(nodeCollection[index].parentNode) !== -1)
                || (nodeCollection[index].nodeType === 3 &&
                    range.startContainer !== range.endContainer &&
                    range.startContainer.parentNode !== range.endContainer.parentNode) &&
                    range.startContainer.parentNode.tagName && range.endContainer.parentNode.tagName &&
                    CONSTANT.BLOCK_TAGS.indexOf(range.startContainer.parentNode.tagName.toLowerCase()) !== -1
                    && CONSTANT.BLOCK_TAGS.indexOf(range.endContainer.parentNode.tagName.toLowerCase()) !== -1) {
                nodeCollection.splice(index, 1);
                index--;
            }
            else if (nodeCollection[index].nodeType === 3) {
                nodeCollection[index] = nodeCollection[index].parentNode;
            }
        }
        return nodeCollection;
    }
    /**
     * getSelectionNodeCollection method
     *
     * @param {Range} range - specifies the range value.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    getSelectionNodeCollection(range) {
        return this.getSelectionNodes(this.getNodeCollection(range));
    }
    /**
     * getSelectionNodeCollection along with BR node method
     *
     * @param {Range} range - specifies the range value.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    getSelectionNodeCollectionBr(range) {
        return this.getSelectionNodesBr(this.getNodeCollection(range));
    }
    /**
     * getParentNodes method
     *
     * @param {Node[]} nodeCollection - specifies the collection of nodes.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    getSelectionNodes(nodeCollection) {
        nodeCollection = nodeCollection.reverse();
        const regEx = new RegExp('\u200B', 'g');
        for (let index = 0; index < nodeCollection.length; index++) {
            if (nodeCollection[index].nodeType !== 3 || (nodeCollection[index].textContent.trim() === '' ||
                (nodeCollection[index].textContent.length === 1 && nodeCollection[index].textContent.match(regEx)))) {
                nodeCollection.splice(index, 1);
                index--;
            }
        }
        return nodeCollection.reverse();
    }
    /**
     * Get selection text nodes with br method.
     *
     * @param {Node[]} nodeCollection - specifies the collection of nodes.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    getSelectionNodesBr(nodeCollection) {
        nodeCollection = nodeCollection.reverse();
        for (let index = 0; index < nodeCollection.length; index++) {
            if (nodeCollection[index].nodeName !== 'BR' &&
                (nodeCollection[index].nodeType !== 3 || ((nodeCollection[index].textContent.trim() === '' && !this.isSurroundedByInline(nodeCollection[index])) && !nodeCollection[index].textContent.includes('\u00A0')))) {
                nodeCollection.splice(index, 1);
                index--;
            }
        }
        return nodeCollection.reverse();
    }
    isBlocElement(element) {
        return (!!element && (element.nodeType === Node.ELEMENT_NODE && CONSTANT.BLOCK_TAGS.indexOf(element.tagName.toLowerCase()) >= 0));
    }
    isSurroundedByInline(node) {
        let previousSibling = node.previousSibling;
        let nextSibling = node.nextSibling;
        while (!this.isBlocElement(node) && !previousSibling && !nextSibling) {
            node = node.parentNode;
            previousSibling = node.previousSibling;
            nextSibling = node.nextSibling;
        }
        let previousInline = false;
        let nextInline = false;
        if (previousSibling && !this.isBlocElement(previousSibling)) {
            previousInline = true;
        }
        if (nextSibling && !this.isBlocElement(nextSibling)) {
            nextInline = true;
        }
        if (previousInline && nextInline) {
            return true;
        }
        return false;
    }
    /**
     * getInsertNodeCollection method
     *
     * @param {Range} range - specifies the range value.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    getInsertNodeCollection(range) {
        return this.getInsertNodes(this.getNodeCollection(range));
    }
    /**
     * getInsertNodes method
     *
     * @param {Node[]} nodeCollection - specifies the collection of nodes.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    getInsertNodes(nodeCollection) {
        nodeCollection = nodeCollection.reverse();
        for (let index = 0; index < nodeCollection.length; index++) {
            if ((nodeCollection[index].childNodes.length !== 0 &&
                nodeCollection[index].nodeType !== 3) ||
                (nodeCollection[index].nodeType === 3 &&
                    nodeCollection[index].textContent === '')) {
                nodeCollection.splice(index, 1);
                index--;
            }
        }
        return nodeCollection.reverse();
    }
    /**
     * getNodeArray method
     *
     * @param {Node} node - specifies the node content.
     * @param {boolean} isStart - specifies the boolean value.
     * @param {Document} root - specifies the root document.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    getNodeArray(node, isStart, root) {
        const array = [];
        // eslint-disable-next-line
        ((isStart) ? (this.startNodeName = []) : (this.endNodeName = []));
        for (; node !== (root ? root : this.rootNode); null) {
            if (isNullOrUndefined(node)) {
                break;
            }
            // eslint-disable-next-line
            (isStart) ? this.startNodeName.push(node.nodeName.toLowerCase()) : this.endNodeName.push(node.nodeName.toLowerCase());
            array.push(this.getIndex(node));
            node = node.parentNode;
        }
        return array;
    }
    setRangePoint(range, isvalid, num, size) {
        let node = this.rootNode;
        let index = num.length;
        let constant = size;
        for (; index--; null) {
            node = node && node.childNodes[num[index]];
        }
        if (node && constant >= 0 && node.nodeName !== 'html') {
            if (node.nodeType === 3 && node.nodeValue.replace(/\u00a0/g, '&nbsp;') === '&nbsp;') {
                constant = node.textContent.length;
            }
            else if (node.nodeType !== 3) {
                constant = Math.min(constant, node.childNodes.length);
            }
            range[isvalid ? 'setStart' : 'setEnd'](node, constant);
        }
        return range;
    }
    /**
     * restore method
     *
     * @returns {void}
     * @hidden
     * @deprecated
     */
    restore() {
        if (!this || !this.range) {
            return null;
        }
        let range = this.range.cloneRange();
        range = this.setRangePoint(range, true, this.startContainer, this.startOffset);
        range = this.setRangePoint(range, false, this.endContainer, this.endOffset);
        this.selectRange(this.rootNode, range);
        return range;
    }
    selectRange(docElement, range) {
        this.setRange(docElement, range);
        this.save(range, docElement);
    }
    /**
     * setRange method
     *
     * @param {Document} docElement - specifies the document.
     * @param {Range} range - specifies the range.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    setRange(docElement, range) {
        const selection = this.get(docElement);
        selection.removeAllRanges();
        selection.addRange(range);
    }
    /**
     * setSelectionText method
     *
     * @param {Document} docElement - specifies the documrent
     * @param {Node} startNode - specifies the starting node.
     * @param {Node} endNode - specifies the the end node.
     * @param {number} startIndex - specifies the starting index.
     * @param {number} endIndex - specifies the end index.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    setSelectionText(docElement, startNode, endNode, startIndex, endIndex) {
        const range = docElement.createRange();
        range.setStart(startNode, startIndex);
        range.setEnd(endNode, endIndex);
        this.setRange(docElement, range);
    }
    /**
     * setSelectionContents method
     *
     * @param {Document} docElement - specifies the document.
     * @param {Node} element - specifies the node.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    setSelectionContents(docElement, element) {
        const range = docElement.createRange();
        range.selectNode(element);
        this.setRange(docElement, range);
    }
    /**
     * setSelectionNode method
     *
     * @param {Document} docElement - specifies the document.
     * @param {Node} element - specifies the node.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    setSelectionNode(docElement, element) {
        const range = docElement.createRange();
        range.selectNodeContents(element);
        this.setRange(docElement, range);
    }
    /**
     * getSelectedNodes method
     *
     * @param {Document} docElement - specifies the document.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    getSelectedNodes(docElement) {
        return this.getNodeCollection(this.getRange(docElement));
    }
    /**
     * Clear method
     *
     * @param {Document} docElement - specifies the document.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    Clear(docElement) {
        this.get(docElement).removeAllRanges();
    }
    /**
     * insertParentNode method
     *
     * @param {Document} docElement - specifies the document.
     * @param {Node} newNode - specicfies the new node.
     * @param {Range} range - specifies the range.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    insertParentNode(docElement, newNode, range) {
        range.surroundContents(newNode);
        this.selectRange(docElement, range);
    }
    /**
     * setCursorPoint method
     *
     * @param {Document} docElement - specifies the document.
     * @param {Element} element - specifies the element.
     * @param {number} point - specifies the point.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    setCursorPoint(docElement, element, point) {
        const range = docElement.createRange();
        const selection = docElement.defaultView.getSelection();
        range.setStart(element, point);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);
    }
    isTableOrImageStart(range) {
        const customHandlerElements = ['TABLE'];
        const startContainer = range.startContainer;
        const startOffset = range.startOffset;
        const startNode = startContainer.childNodes[startOffset];
        const isCursorAtStart = range.collapsed && (startContainer.nodeType === 1) &&
            startContainer.isContentEditable && startNode &&
            (customHandlerElements.indexOf(startNode.nodeName) > -1);
        if (isCursorAtStart) {
            return { start: isCursorAtStart, startNodeName: startNode.nodeName, startNode: startNode };
        }
        else {
            return { start: false, startNodeName: '', startNode: undefined };
        }
    }
    isTableOrImageEnd(range) {
        const customHandlerElements = ['TABLE'];
        const startContainer = range.startContainer;
        const startOffset = range.startOffset;
        const endNode = startContainer.childNodes[startOffset - 1];
        const isCursorAtEnd = range.collapsed && (startContainer.nodeType === 1) &&
            startContainer.isContentEditable && endNode &&
            (customHandlerElements.indexOf(endNode.nodeName) > -1);
        if (isCursorAtEnd) {
            return { end: isCursorAtEnd, endNodeName: endNode.nodeName, endNode: endNode };
        }
        else {
            return { end: false, endNodeName: '', endNode: undefined };
        }
    }
    processedTableImageCursor(range) {
        const { start, startNodeName, startNode } = this.isTableOrImageStart(range);
        const { end, endNodeName, endNode } = this.isTableOrImageEnd(range);
        return { start, startName: startNodeName, end, endName: endNodeName, startNode, endNode };
    }
    findLastTextPosition(element) {
        if (element.nodeType === Node.TEXT_NODE) {
            return { node: element, offset: element.textContent ? element.textContent.length : 0 };
        }
        if (element.nodeName === 'BR') {
            return { node: element, offset: 0 };
        }
        for (let i = element.childNodes.length - 1; i >= 0; i--) {
            const lastPosition = this.findLastTextPosition(element.childNodes[i]);
            if (lastPosition) {
                return lastPosition;
            }
        }
        return null;
    }
    findFirstTextNode(node) {
        if (node.nodeType === Node.TEXT_NODE) {
            return node;
        }
        for (let i = 0; i < node.childNodes.length; i++) {
            const textNode = this.findFirstTextNode(node.childNodes[i]);
            if (!isNullOrUndefined(textNode)) {
                return textNode;
            }
        }
        return null;
    }
    findFirstContentNode(node) {
        if (node.nodeType === Node.TEXT_NODE) {
            return { node: node, position: 0 };
        }
        if (node.nodeName === 'BR') {
            return { node: node, position: 0 };
        }
        for (let i = 0; i < node.childNodes.length; i++) {
            const result = this.findFirstContentNode(node.childNodes[i]);
            if (result.node !== null) {
                return result;
            }
        }
        return { node: node, position: 0 };
    }
}
